import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";

export const DOWNLOAD_ORDER_FIELDS = `
    id
    trackingNumber
    channelId
    channelOrderNumber
    orderTime
    overallStatus
    receivedAtHub
    lastDeliveryScanTime
    isDelivered
    isIntercepted
    isAbnormal
    expectedDeliveryTime
    deliveredAt
    deliveryAttempts
    exceptionReasonCode
    weightLb
    volumetricWeightLb
    lengthIn
    widthIn
    heightIn
    packageValueUsd
    originalWeightLb
    originalLengthIn
    originalWidthIn
    originalHeightIn
    sortingCode
    receiverZipcode
    senderAddressId
    recipientAddressId
    pickupHubId
    destWarehouseId
    zone
    slaTime
    orderPrice
    deliveredDspId
    deliveredDriverAccountId
    updatedAt
    recipientAddress {
        id
        fullName
        countryCode
        phoneNumber
        addressLine1
        addressLine2
        city
        state
        zipcode
        company
        instructions
    }
    senderAddress {
        id
        fullName
        countryCode
        phoneNumber
        extension
        addressLine1
        addressLine2
        city
        state
        zipcode
        company
        instructions
    }
    pickupHub {
        id
        name
        siteType
    }
    destWarehouse {
        id
        name
        siteType
    }
    dsp {
        id
        name
    }
    driver {
        id
        name
    }
    channel {
        id
        channelName
    }
`;

export const DOWNLOAD_ALL_ORDERS_FOR_CENTRAL = gql`
    query DownloadAllOrdersForCentral($filters: OrderFiltersTypeInput, $pageRequest: PageRequestTypeInput) {
        getOrderListingForCentralOptimized(filters: $filters, pageRequest: $pageRequest) {
            content {
                ${DOWNLOAD_ORDER_FIELDS}
            }
            totalElements
        }
    }
`;

export interface DownloadAllOrdersForCentralResponse {
    getOrderListingForCentralOptimized: {
        content: OrderType[];
        totalElements: number;
    };
}

export interface DownloadAllOrdersForCentralVariables {
    filters?: OrderFiltersType;
    pageRequest?: {
        page: number;
        size: number;
        sortBy: string;
        sortDirection: string;
    };
}